import { AiFillAppstore } from "react-icons/ai";
import { FaMobile, FaGlobe } from "react-icons/fa";
import { SiProgress, SiAntdesign } from "react-icons/si";

export const featuresData = [
  {
    id: 1,
    icon: <AiFillAppstore />,
    title: "Full Stack Development",
    des: "Build robust web applications using modern JavaScript frameworks, delivering scalable solutions.",
  },
  {
    id: 2,
    icon: <SiProgress />,
    title: "Backend & API Engineering",
    des: "Develop secure, efficient backends with Node.js and Express to power dynamic web apps.",
  },
  {
    id: 3,
    icon: <FaGlobe />,
    title: "Database Optimization",
    des: "Implement and fine-tune MongoDB and SQL databases for fast, reliable data management.",
  },
  {
    id: 4,
    icon: <SiAntdesign />,
    title: "Responsive UI/UX Design",
    des: "Design intuitive, responsive user interfaces with React.js that enhance user experience.",
  },
  {
    id: 5,
    icon: <FaMobile />,
    title: "Mobile-First Solutions",
    des: "Ensure cross-platform compatibility and mobile responsiveness across all projects.",
  },
  {
    id: 6,
    icon: <AiFillAppstore />,
    title: "Freelance & Custom Projects",
    des: "Deliver tailored full stack solutions that boost client engagement and streamline operations.",
  },
];
